import React, { Component, PropTypes } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import InfoIcon from '../../svgs/InfoIcon';
import CloseX from '../../svgs/CloseX';

export default class Notification extends Component {
  static propTypes = {
    alerts: PropTypes.array.isRequired,
    dismiss: PropTypes.func,
    navigate: PropTypes.func
  }

  constructor(props) {
    super(props);

    this.dismissNotification = ::this.dismissNotification;
    this.renderUserAlert = ::this.renderUserAlert;
    this.renderJobRequestAlert = ::this.renderJobRequestAlert;
  }

  dismissNotification(id) {
    this.props.dismiss(id);
  }

  renderUserAlert(alert) {
    return (
      <div className='notification' key={alert.id}>
        <div className='left-side'>
          <InfoIcon />
          <div className='user-alert-message'>
            <span className='notification-link' onClick={() => this.props.navigate(alert, 'user')}>{alert.alertData.name}</span>
            &nbsp;{alert.alertData.actionLong || alert.alertData.action}&nbsp;
            <span className='notification-link' onClick={() => this.props.navigate(alert, 'location')}>{alert.alertData.locationName || alert.alertData.location}</span>
          </div>
        </div>
        <CloseX className='dismiss-button' onClick={() => this.dismissNotification(alert.id, true)} />
      </div>
    );
  }

  renderJobRequestAlert(alert) {
    return (
      <div className='notification' key={alert.id}>
        <div className='left-side'>
          <InfoIcon />
          <div className='job-request-alert-message'>
            { alert.alertData.prefixMessage }&nbsp;
            <span className='notification-link' onClick={() => this.props.navigate(alert, null, `/admin/contacts/${alert.alertData.target}/details`)}>{ alert.alertData.name }</span>,&nbsp;
            { alert.alertData.title }&nbsp;<span className='notification-link' onClick={() => this.props.navigate(alert, null, `/admin/companies/${alert.alertData.companyId}/details`)}>{ alert.alertData.companyName }</span>
            { alert.alertData.companyStatus === 4 && alert.alertData.suffixMessageActiveAccount }
            { (alert.alertData.companyStatus === 1  || alert.alertData.companyStatus === 2) && alert.alertData.suffixMessageProspect }
          </div>
        </div>
        <CloseX className='dismiss-button' onClick={() => this.dismissNotification(alert.id, true)} />
      </div>
    );
  }


  render() {
    return(
      <div className='notification-container'>
        <ReactCSSTransitionGroup
          transitionName='notify'
          transitionEnterTimeout={500}
          transitionLeaveTimeout={300}
          transitionAppearTimeout={500}
          transitionAppear
          key='notification'>
          {this.props.alerts.map((alert) => {
            switch(alert.alertData.type) {
              case('JobRequestAlert'):
                return this.renderJobRequestAlert(alert);
              case('UserAlert'):
              default:
                return this.renderUserAlert(alert);
            }
          }, this)}
        </ReactCSSTransitionGroup>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/common/components/Notification/index.js